import '@babel/polyfill';
import SmoothScroll from 'smoothscroll-polyfill';
import LazyLoad from 'vanilla-lazyload';
import Pikaday from 'pikaday';
import 'bootstrap-sass/assets/javascripts/bootstrap/tab';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import SimpleLightbox from "simplelightbox";
import Carousel from './components/Carousel';
import Video from './components/Video';
import Menu from './components/Menu';
import WishList from './components/WishList';
import ImagePlaceholder from './components/ImagePlaceholder';
import GeoChart from './components/GeoChart';
import Map from './components/Map';
import ViewAllTabs from './components/ViewAllTabs';
import GallerySlider from './components/GallerySlider';
import Share from './components/Share';
import ContactBar from './components/ContactBar';
import HighLights from './components/Highlights';
import Newsletter from './components/Newsletter';
import HeaderSlider from './components/HeaderSlider';
import Dropdown from './components/Dropdown';
import MobileNavigation from './components/MobileNavigation';
import ReadMore from './components/ReadMore';
import Sliders from './components/Sliders';
// import CurrencySwitcher from './components/CurrencySwitcher';
import Popup from "./components/Popup";
import Forms from "./components/Forms";
import NewsletterModal from "./components/NewsletterModal";
import LatestPosts from "./components/LatestPosts";
import ContentSlider from './components/ContentSlider';

require('jquery-sticky/jquery.sticky');

class App {
  static init() {
    SmoothScroll.polyfill();
    (new Carousel().render());
    (new Video()).init();
    (new Menu().init());
    (new WishList().init());
    (new ImagePlaceholder().init());
    (new GeoChart().init());
    (new Map().init());
    (new ViewAllTabs().init());
    (new GallerySlider().init());
    (new Share().init());
    (new ContactBar().init());
    (new HighLights().init());
    (new Newsletter().init());
    (new HeaderSlider().init());
    (new Dropdown().init());
    (new MobileNavigation().init());
    (new ReadMore().init());
    (new Sliders().init());
    // (new CurrencySwitcher().init());
    (new Popup()).init();
    (new Forms().init());
    (new NewsletterModal()).init();
    (new LatestPosts()).init();
    (new ContentSlider()).init();
  }
}
App.init();

const header = document.getElementById("mainHeader");

window.onscroll = () => {
  if (window.scrollY > 30) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
};
$('.tab-container').sticky({ topSpacing: 45 });

$('.contact .mobile-row').sticky({ topSpacing: 82 });

$('.nav-pills').find('a').click(() => {
  const sticky = document.querySelectorAll('.sticky-wrapper').length >= 2 ? document.querySelectorAll('.sticky-wrapper')[1] : false;
  if (sticky) {
    sticky.scrollIntoView({ behavior: 'smooth' });
  }
});
if ($('.media-section .image-box a').length) {
  // eslint-disable-next-line
  $('.media-section').each((_index, item) => new SimpleLightbox($(item).find('.image-box a')));
}

if (window.innerWidth > 1200) {
  const lastSubMenu = $('.menu-item.special-dropdown > .sub-menu > li').last();
  const lastSubMenuContent = lastSubMenu.html();
  lastSubMenu.detach();
  $(lastSubMenuContent).appendTo($('.menu-item.special-dropdown > .sub-menu > li').last());
}

if ($('.highlights-slider').length) {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $('.highlights-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            arrows: false,
            slidesToShow: 1,
            autoplaySpeed: 2200,
          },
        },
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            slidesToShow: 2,
            autoplaySpeed: 2200,
          },
        },
      ],
    });
  })
}

if ($('.js-page-boxes').length) {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $('.js-page-boxes').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: true,
      arrows: false,
      infinite: false,
    });
  })
}

if ($('.js-itinerary-carousel').length) {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $('.js-itinerary-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: false,
      arrows: true,
      prevArrow: $('.js-arrow-prev'),
      nextArrow: $('.js-arrow-next'),
      infinite: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dots: false,
          },
        },
      ],
    });

    $('.js-itinerary-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.js-itinerary-carousel',
      dots: false,
      arrows: false,
      infinite: false,
      focusOnSelect: true
    });

    $('.js-itinerary-nav .slick-slide').removeClass('slick-active');

    $('.js-itinerary-nav .slick-slide').eq(0).addClass('slick-current');

    $('.js-itinerary-carousel').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const mySlideNumber = nextSlide;
      $('.js-itinerary-nav .slick-slide').removeClass('slick-current');
      $('.js-itinerary-nav .slick-slide').eq(mySlideNumber).addClass('slick-current');
    });
  })
}

if ($('.js-team-slider').length) {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $('.js-team-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
  })
}

if ($('.js-trips-slider').length) {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $('.js-trips-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
  });
}

$('.social__item, .share__item').hover(function hover() {
  $(this).find('.svg-container').toggleClass('onHover');
});

$(() => {
  $('a[data-toggle="tab"]').on('click', (e) => {
    const resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(resizeEvent);
    window.google.maps.event.trigger(e, 'resize');
  });

  window.addEventListener('resize', () => {
    const $iframe = $('.tab-pane.active').find('.reviews iframe');
    $iframe.attr('height', '');
  });

  $('*[data-scroll-next]').on('click', (e) => {
    e.preventDefault();
    $('main').find('section')[0].scrollIntoView({ behavior: 'smooth' });
  })
  // eslint-disable-next-line
  const datePicker = new Pikaday({
    field: document.getElementById('datepicker'),
    format: 'DD-MM-YYYY',
    minDate: new Date(),
    keyboardInput: false,
  });
});

$(() => {
  const elementsToLazyLoad = document.querySelectorAll('img.lazy, div.lazy, a.lazy');
  // eslint-disable-next-line
  const lazy = new LazyLoad({}, elementsToLazyLoad);
  // eslint-disable-next-line
  const iframesLazy = new LazyLoad({
    elements_selector: 'iframe.lazy',
    threshold: 500,
    callback_loaded: (el) => {
      const $iframe = $(el);
      setTimeout(() => {
        const $css = $('#main-css-css').clone();
        $iframe.contents().find('head').append($css);
        $iframe.contents().find('a[href$="#"]').click((e) => {
          e.preventDefault();
        });
      }, 200);
    },
  })
});

$('a[href="mailto:info@offthemap.travel"]').on('click', () => {
  window.gtag('event', 'Clicked', {
    'event_category': 'EmailLink',
    'event_label': 'info@offthemap.travel'});
});
